(function () {

  'use strict';

  function pxUpdatePrintixClientOnWorkstationDialog(
    $filter, toastr, ApplicationType, CpuArchitecture, FileType, OperatingSystem, PrintixVersion, SoftwareService
  ) {
    return {
      restrict: 'E',
      scope: {
        workstation: '=',
        onClose: '&'
      },
      templateUrl: 'app/components/workstationList/updatePrintixClientOnWorkstationDialog.template.html',
      link: function (scope, element, attributes) {

        scope.availableVersions = [];
        scope.selectedVersion = {};

        scope.onConfirmDialog = function () {
          forcePrintixClientVersionOnWorkstation();
        };

        scope.onCancelDialog = function () {
          scope.onClose();
        };

        (function () {
          scope.operatingSystem = getWorkstationOperatingSystem(scope.workstation);
          scope.cpuArchitecture = getWorkstationCpuArchitecture(scope.workstation);
          scope.currentVersion = scope.workstation.info.clientVersion;
          loadVersionsOfDesktopApplications();
        })();

        function loadVersionsOfDesktopApplications() {
          scope.working = true;
          SoftwareService.getVersionsOfDesktopApplications()
            .then(function (versions) {
              scope.desktopApplicationVersions = versions;
              populateDropdownWithAvailableVersions();
            })
            .catch(function () {
              toastr.error($filter('translate')('ERROR'));
              scope.onClose();
            })
            .finally(function () {
              scope.working = false;
            });
        }

        function populateDropdownWithAvailableVersions() {
          const application = scope.desktopApplicationVersions.applications
            .find(application => application.appType === ApplicationType.CLIENT && application.os === scope.operatingSystem);
          if (application) {
            const currentVersion = new PrintixVersion(scope.currentVersion);
            let availableVersions = application.availableVersions
              .filter(availableVersion => currentVersion.compareTo(new PrintixVersion(availableVersion.version)) === -1);
            if (application.os === OperatingSystem.WIN) {
              availableVersions = availableVersions.filter(availableVersion => availableVersion.files.some(file => file.type === FileType.EXE && file.cpuArch === scope.cpuArchitecture));
            } else if (application.os === OperatingSystem.MAC) {
              availableVersions = availableVersions.filter(availableVersion => availableVersion.files.some(file => file.type === FileType.DMG));
            }
            scope.availableVersions = availableVersions.sort((a, b) => new PrintixVersion(b.version).compareTo(new PrintixVersion(a.version)));
          }
        }

        function getWorkstationOperatingSystem() {
          const osName = scope.workstation.info.operatingSystem;
          if (osName.startsWith('WIN')) {
            return OperatingSystem.WIN;
          } else if (osName.startsWith('MAC')) {
            return OperatingSystem.MAC;
          }
          return undefined;
        }

        function getWorkstationCpuArchitecture() {
          const osName = scope.workstation.info.operatingSystem;
          if (osName.startsWith('WIN')) {
            if (osName.endsWith('_32')) {
              return CpuArchitecture.X86;
            } else if (osName.endsWith('_64')) {
              return CpuArchitecture.X64;
            } else if (osName.endsWith('_ARM64')) {
              return CpuArchitecture.ARM64;
            }
          }
          return undefined;
        }

        function forcePrintixClientVersionOnWorkstation() {
          scope.working = true;
          SoftwareService.forcePrintixClientVersionOnWorkstation(scope.workstation.customProperties.id, scope.selectedVersion.value.version)
            .then(function () {
              scope.onClose();
            })
            .catch(function () {
              toastr.error($filter('translate')('ERROR'));
            })
            .finally(function () {
              scope.working = false;
            });
        }

      }
    };
  }

  pxUpdatePrintixClientOnWorkstationDialog.$inject = [
    '$filter', 'toastr', 'ApplicationType', 'CpuArchitecture', 'FileType', 'OperatingSystem', 'PrintixVersion', 'SoftwareService'
  ];

  angular
    .module('printix-admin')
    .directive('pxUpdatePrintixClientOnWorkstationDialog', pxUpdatePrintixClientOnWorkstationDialog);

})();
